import styled from 'styled-components'
import { rem } from 'polished'
import Sheet from 'components/utils/Sheet'
import { fadeSlideIn } from 'components/utils/animations'
import zIndex from 'styles/tools/z-index'

/** The card a composer prompt is drawn on, hidden until `usePromptPosition` says it's visible */
const PromptCard = styled(Sheet)`
  max-inline-size: calc(100vw - ${rem(32)});
  z-index: ${zIndex.tooltip};
  visibility: hidden;
  animation: ${fadeSlideIn} 0.35s ease-out;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }

  &.visible {
    visibility: visible;
  }
`

export default PromptCard
